import { deepCopy } from "./utils.helper";

// Children contentType are references which are comming in fields[i].validations[j].linkContentType[]
type T_ReferenceContentType = string;

// Fields type
type T_ContentTypeField = {
  id?: string, // fields[i].id
  name?: string, // fields[i].name
  type?: string, // fields[i].type
  localized?: boolean, // fields[i].localized
  required?: boolean, // fields[i].required
  disabled?: boolean, // fields[i].disabled
  omitted?: boolean, // fields[i].omitted
  linkTyle?: string, // fields[i].linkTyle
  validations?: T_ReferenceContentType[] //fields[i].validations[j].linkContentType[]
}

type T_ContentType = {
  id?: string, // sys.space.id
  name?: string, // name
  description?: string, // description
  type?: string, // sys.type
  fields: T_ContentTypeField[], // fields
  createdAt?: string //Date, // sys.createdAt
  updatedAt?: string //Date // sys.updatedAt
}

type T_ContentTypeResp = {
  "sys": {
    "space": {
      "sys": T_Sys
    },
    "id": string,
    "type": string,
    "createdAt": string,
    "updatedAt": string,
    "environment": {
      "sys": T_Sys
    },
    "revision": number
  },
  "displayField": string,
  "name": string,
  "description": string,
  "fields": T_ContentTypeField[]
}

type T_Sys = {
  id?: string,
  type?: string,
  linkType?: string
}

type T_Metadata = {
  tags: []
}
type T_Items = {
  metadata: T_Metadata,
  sys: T_Sys,
  fields: []
}

type T_Entry = {
  metadata: T_Metadata,
  sys: T_Sys,
  fiield: any[]
}
type T_Includes = {
  Entry: T_Entry[],
  Asset?: {
    metadata: {
      tags: any[]
    },
    sys: {
      space: {
        sys: T_Sys
      }
    }
  }[]
}

type T_Resp = {
  sys: T_Sys,
  total: number,
  skip: number,
  limit: number,
  items?: any[],
  fields?: any,
  includes?: T_Includes
}

type T_Content = {
  total: number,
  skip: number,
  limit: number,
  items: any[]
}

type T_ResponseStruct = {
  message: string,
  data: T_Content
}

type T_TypeResponseStruct = {
  message: string,
  struct: T_ContentType
}



const getFieldContent = async (id: string, includes?: any, dataKey: string = "Entry", outPut?: any) => {
  const entry = includes[dataKey]?.find((en: any) => en?.sys?.id === id);
  // console.log("entry ---- ", entry);
  return {
    id: id,
    // sys: {
    //   id: entry?.sys?.id,
    //   type: entry?.sys?.type
    // },
    sys: entry?.sys,
    __typename: entry?.sys?.type,
    internalName: entry?.fields?.internalName || "", // res.includes[i].Entry[j].fields.internalName
    title: entry?.fields?.internalName || entry?.fields?.contentTitle || entry?.fields?.title || "", // res.includes[i].Entry[j].fields.title
    isBanner: entry?.fields?.isBanner || "", // res.includes[i].Entry[j].fields.isBanner
    contentType: entry?.sys?.contentType?.sys?.id || entry?.sys?.linkType || entry?.sys?.type || "", // res.includes[i].Entry[j].sys.contentType.sys.id
    type: entry?.sys?.type || "",
    content: await getFileds(entry, includes),
    createdAt: entry?.sys?.createdAt || "", // res.includes[i].Entry[j].sys.createdAt
    updatedAt: entry?.sys?.updatedAt || "", // res.includes[i].Entry[j].sys.updatedAt
    locale: entry?.sys?.locale || "" // res.includes[i].Entry[j].sys.locale
  }
}

const getFileds = async (item: any, includes?: any) => {
  let newItem: any = {};
  if (item?.fields) {
    for (const key in item?.fields) {
      const val: any = deepCopy(item.fields[key]);
      // console.log("Response Key ---- ", key, " | ", val);
      // if(key === "file") { newItem["blurURL"] = await dynamicBlurDataUrl(val?.src ? "https:" + val?.src : "/"); }
      if (key !== "contentTitle" && key !== "title") {
        if (Array.isArray(val)) {
          if (typeof (val[0]) !== 'object') {
            newItem[key] = deepCopy(val)
          } else {
            newItem[key] = await Promise.all(val.map(async (v: any) => {
              return await getFieldContent(v?.sys?.id, includes, v?.sys?.linkType)
            }))
          }

        } else if (typeof (val) === "object") {
          newItem[key] = deepCopy(val?.sys?.linkType ? await getFieldContent(val?.sys?.id, includes, val?.sys?.linkType) : val)
        } else {
          newItem[key] = deepCopy(val)
        }
      }
    }
  }
  return newItem;
}

const setContentResp = async (res: T_Resp) => {
  return {
    total: 0,
    skip: 0,
    limit: 100,
    items: await (async () => {

      const items = res?.items || [res]

      if (items && items[0]?.fields && Object.keys(items[0]?.fields)?.length > 0) {
        return await Promise.all(items?.map(async (itm: any, index: number) => {
          return await (async () => {
            return {
              id: itm?.sys?.id,
              sys: itm?.sys,
              __typename: itm?.sys?.type,
              contentType: itm?.sys?.contentType?.sys?.id || itm?.sys?.contentType?.id || itm?.sys?.linkTyle,
              title: itm?.fields?.internalName || itm?.fields?.contentTitle || itm?.fields?.name || itm?.fields?.contentName,
              content: await getFileds(deepCopy(itm), res?.includes),
              createdAt: itm?.sys?.createdAt,
              updatedAt: itm?.sys?.updatedAt,
              locale: itm?.sys?.locale
            }
          })();
        }))
      }
    })() || []
  }
}

const setContentTypeResp = (res: T_ContentTypeResp) => {
  return {
    id: res?.sys?.id || "", // res.sys.id
    sys: res?.sys,
    name: res?.name || "", // res.name
    description: res?.description || "", // res.description
    type: res?.sys.type || "", // res.sys.type
    fields: res?.fields?.map((f: any) => {

      return f;
    }) || [], // res.fields
    createdAt: res?.sys?.createdAt || "", // res.sys.createdAt
    updatedAt: res?.sys?.updatedAt || "" // res.sys.updatedAt
  }
}

export const ApiResponse = ({ res = {}, error, contentType = false }: { res?: any, error?: any, contentType?: boolean }) => {
  if (error) return { message: error?.message }
  if (contentType) {
    return {
      message: "",
      struct: setContentTypeResp(res)
    }
  } else {
    return {
      message: "",
      data: setContentResp(res)
    }
  }
}

export type T_ResponseMessageType = "success" | "error" | "warning" | "info";
export type T_ResponseOperator = "equals" | "notEquals" | "includes" | "exists" | "isEmpty" | "gt" | "gte" | "lt" | "lte" | "matches";

export type T_ResponseRule = {
  path: string;
  operator: T_ResponseOperator;
  value?: any;
  regex?: string;
};

export type T_ResponseCondition = {
  name?: string;
  statusRange?: [number, number];
  and?: T_ResponseRule[];
  or?: T_ResponseRule[];
  message: string | Record<string, string>;
  messageType?: T_ResponseMessageType;
};

export type T_ResponseMapConfig = {
  messages?: {
    extraction?: {
      successPath?: string;
      errorPath?: string;
      fallback?: string | Record<string, string>;
    };
    statusCodeMap?: Record<string | number, string | Record<string, string> | { message: string | Record<string, string>; messageType?: T_ResponseMessageType }>;
    conditions?: T_ResponseCondition[];
    transformer?: (resolvedMessage: string, locale: string, response: any) => string;
  };
  dataExtraction?: {
    enabled?: boolean;
    fieldMappings?: Record<string, {
      path: string;
      type?: string;
      transformer?: (value: any) => any;
      required?: boolean;
    }>;
    behavior?: {
      autoPopulate?: boolean;
      storeInSession?: boolean;
      passToNextApi?: boolean;
    };
  };
  i18n?: {
    fallbackLocale?: string;
  };
  monitoring?: {
    logLevel?: "none" | "warn" | "verbose";
    logPrefix?: string;
  };
};

export type T_ResolvedResponseMessage = {
  text: string;
  messageType: T_ResponseMessageType;
  source: "statusCode" | "condition" | "extraction" | "fallback";
  matchedRule?: string;
};

const normalizePath = (path: string) => path.replace(/\[(\d+)\]/g, ".$1").replace(/\.\./g, ".").replace(/^\./, "");

export const getValueByDotPath = (source: any, path: string): any => {
  if (!source || !path) return undefined;

  const normalizedPath = normalizePath(path);
  return normalizedPath.split(".").filter(Boolean).reduce((current: any, key: string) => current?.[key], source);
};

const resolveLocalizedText = (value: string | Record<string, string> | undefined, locale: string, fallbackLocale: string = "en") => {
  if (typeof value === "string") return value;
  if (!value) return "";

  return value?.[locale] || value?.[fallbackLocale] || value?.en || Object.values(value)?.find((entry) => typeof entry === "string") || "";
};

const interpolateMessage = (message: string, response: any) => {
  if (!message) return "";

  return message.replace(/#\{([^}]+)\}/g, (_, path: string) => {
    const resolvedValue = getValueByDotPath(response, path.trim());
    if (resolvedValue === undefined || resolvedValue === null) return "";
    return typeof resolvedValue === "string" || typeof resolvedValue === "number" || typeof resolvedValue === "boolean"
      ? String(resolvedValue)
      : JSON.stringify(resolvedValue);
  });
};

const evaluateRule = (response: any, rule: T_ResponseRule) => {
  const actualValue = getValueByDotPath(response, rule.path);

  switch (rule.operator) {
    case "exists":
      return actualValue !== undefined && actualValue !== null && actualValue !== "";
    case "isEmpty":
      return actualValue === undefined || actualValue === null || actualValue === "" || (Array.isArray(actualValue) && actualValue.length === 0);
    case "includes":
      return typeof actualValue === "string" ? actualValue.includes(String(rule.value ?? "")) : Array.isArray(actualValue) ? actualValue.includes(rule.value) : false;
    case "notEquals":
      return actualValue !== rule.value;
    case "gt":
      return Number(actualValue) > Number(rule.value);
    case "gte":
      return Number(actualValue) >= Number(rule.value);
    case "lt":
      return Number(actualValue) < Number(rule.value);
    case "lte":
      return Number(actualValue) <= Number(rule.value);
    case "matches":
      try {
        return new RegExp(rule.regex || String(rule.value || "")).test(String(actualValue ?? ""));
      } catch {
        return false;
      }
    case "equals":
    default:
      return actualValue === rule.value;
  }
};

const matchesCondition = (response: any, condition: T_ResponseCondition, status: number) => {
  if (condition.statusRange && (status < condition.statusRange[0] || status > condition.statusRange[1])) {
    return false;
  }

  const andMatches = condition.and?.length ? condition.and.every((rule) => evaluateRule(response, rule)) : true;
  const orMatches = condition.or?.length ? condition.or.some((rule) => evaluateRule(response, rule)) : true;

  return andMatches && orMatches;
};

const resolveMappedMessageText = (
  message: string | Record<string, string> | { message: string | Record<string, string>; messageType?: T_ResponseMessageType },
  response: any,
  locale: string,
  fallbackLocale: string
) => {
  const messageValue = typeof message === "object" && message !== null && "message" in message ? message.message : message;
  const localizedText = resolveLocalizedText(messageValue as string | Record<string, string>, locale, fallbackLocale);
  return interpolateMessage(localizedText, response);
};

export const extractMappedResponseData = (response: any, config?: T_ResponseMapConfig) => {
  const fieldMappings = config?.dataExtraction?.fieldMappings || {};
  const extractedData: Record<string, any> = {};

  for (const fieldName in fieldMappings) {
    const mapping = fieldMappings[fieldName];
    if (!mapping?.path) continue;

    const rawValue = getValueByDotPath(response, mapping.path);
    if (rawValue === undefined && mapping.required) {
      continue;
    }

    const transformedValue = mapping.transformer ? mapping.transformer(rawValue) : rawValue;
    extractedData[fieldName] = transformedValue;
  }

  return extractedData;
};

export const resolveApiResponseMessage = ({
  response,
  status,
  locale = "en",
  config,
}: {
  response: any;
  status?: number;
  locale?: string;
  config?: T_ResponseMapConfig;
}): T_ResolvedResponseMessage => {

  const normalizedStatus = Number(status || 0);
  const fallbackLocale = config?.i18n?.fallbackLocale || "en";
  const responseBody = response?.json ?? response;
  const monitoringLevel = config?.monitoring?.logLevel || "warn";
  const logPrefix = config?.monitoring?.logPrefix ? `[${config.monitoring.logPrefix}]` : "[ResponseMap]";

  // console.log("resolveApiResponseMessage called with ------------ ", {status, locale, config, response, normalizedStatus, fallbackLocale, responseBody, monitoringLevel, logPrefix});

  // Logging functions based on monitoring level
  const logWarn = (message: string, payload?: any) => {
    if (monitoringLevel !== "none") {
      console.warn(`${logPrefix} ${message}`, payload || {});
    }
  };

  const logVerbose = (message: string, payload?: any) => {
    if (monitoringLevel === "verbose") {
      console.log(`${logPrefix} ${message}`, payload || {});
    }
  };

  // statusCodeMap takes precedence over conditions
  const statusEntry = config?.messages?.statusCodeMap?.[normalizedStatus] || config?.messages?.statusCodeMap?.[String(normalizedStatus)];
  if (statusEntry) {
    const resolvedText = resolveMappedMessageText(statusEntry as any, responseBody, locale, fallbackLocale);
    const messageType: T_ResponseMessageType = typeof statusEntry === "object" && statusEntry !== null && "messageType" in statusEntry
      ? (statusEntry.messageType as T_ResponseMessageType) || (normalizedStatus >= 400 ? "error" : "success")
      : (normalizedStatus >= 400 ? "error" : "success");

    logVerbose("Resolved message from status code", { status: normalizedStatus, resolvedText });
    return {
      text: resolvedText,
      messageType,
      source: "statusCode",
    };
  }

  // Check conditions if no status code mapping was found
  for (const condition of config?.messages?.conditions || []) {
    if (matchesCondition(responseBody, condition, normalizedStatus)) {
      const resolvedText = resolveMappedMessageText(condition.message as any, responseBody, locale, fallbackLocale);
      const transformedText = config?.messages?.transformer
        ? config.messages.transformer(resolvedText, locale, responseBody)
        : resolvedText;

      logVerbose("Resolved message from condition", { condition: condition.name, resolvedText: transformedText });
      return {
        text: transformedText,
        messageType: condition.messageType || (normalizedStatus >= 400 ? "error" : "success"),
        source: "condition",
        matchedRule: condition.name,
      };
    }
  }

  // If no status code mapping or condition matched, attempt to extract a message from the response body
  const extractionPath = normalizedStatus >= 400
    ? config?.messages?.extraction?.errorPath
    : config?.messages?.extraction?.successPath;

  if (extractionPath) {
    const extractedValue = getValueByDotPath(responseBody, extractionPath);
    if (extractedValue !== undefined && extractedValue !== null && extractedValue !== "") {
      const resolvedText = typeof extractedValue === "string" ? extractedValue : JSON.stringify(extractedValue);
      const transformedText = config?.messages?.transformer
        ? config.messages.transformer(resolvedText, locale, responseBody)
        : interpolateMessage(resolvedText, responseBody);

      logVerbose("Resolved message from extraction path", { extractionPath, resolvedText: transformedText });
      return {
        text: transformedText,
        messageType: normalizedStatus >= 400 ? "error" : "success",
        source: "extraction",
      };
    }
  }

  // If all else fails, use the fallback message
  const fallbackMessage = config?.messages?.extraction?.fallback;

  // If no fallback message is provided, use a default message based on the status code
  const fallbackText = resolveLocalizedText(fallbackMessage as string | Record<string, string> | undefined, locale, fallbackLocale)
    || (normalizedStatus >= 400 ? "An error occurred" : "Success");

  logWarn("Falling back to default response message", { status: normalizedStatus, fallbackText });

  // If a transformer is provided, apply it to the fallback text
  const finalText = config?.messages?.transformer
    ? config.messages.transformer(fallbackText, locale, responseBody)
    : fallbackText;

  return {
    text: finalText,
    messageType: normalizedStatus >= 400 ? "error" : "success",
    source: "fallback",
  };
};

